export default __webpack_public_path__ + "static/media/KAVERI_BAGALKOT.23ec7327.JPG";